import FavoritesItemProvider, {
    type FavoritesItemPropsType as FavoritesItemPropsTypeImport,
} from '../src/components/FavoritesItemProvider/FavoritesItemProvider.tsx';

export type FavoritesItemPropsType = FavoritesItemPropsTypeImport;
export default FavoritesItemProvider;
